import EmptyPlaceholder from '../../commons/EmptyPlaceholder';

const FinalTextEmpty = () => {
  return <EmptyPlaceholder placeholder="Aucun textes de fin créés" />;
};

export default FinalTextEmpty;
